import actionTypes from './video.actionTypes';
import * as VideoApiService from '../../../Common/Services/VideoApiService';
import { getToken } from '../../../Common/Services/ServiceBase';
import config from '../../../../Config';


export const loadVideoPlayer = (companyId, isPublicForm) => {
  return async (dispatch, getState) => {

    const dispatchFailures = () => {
      dispatch({ type: actionTypes.GET_VIDEO_CONFIGURATION_FAILURE });
      dispatch({ type: actionTypes.SET_VIDEO_V2_CONFIGURATION_FAILURE });
    };

    try {
      if (getState().video.isVideoPlayerLoaded) return;

      jQuery.ajaxSetup({ cache: true });

      let videoConfiguration = getState().video.configuration;
      if (!videoConfiguration) {
        dispatch({ type: actionTypes.GET_VIDEO_CONFIGURATION_BEGIN });

        let response = await VideoApiService.getVideoConfiguration(companyId, isPublicForm);

        if (response) {        
          let configuration = response;
          dispatch({ type: actionTypes.GET_VIDEO_CONFIGURATION_SUCCESS, data: { configuration } });
          dispatch(setVideoV2Configuration(configuration));
          dispatch(getVideoPlayerScript(configuration));
        }
        else {
          dispatchFailures();
        }
      } else {
        dispatch(setVideoV2Configuration(videoConfiguration));
        dispatch(getVideoPlayerScript(videoConfiguration));
      }
    } catch (error) {
      dispatchFailures();
    }
    
  };
};

const setVideoV2Configuration = (configuration) => {
  return async (dispatch) => {
    try {
      const isVideoV2Enabled = (configuration && configuration.videoV2Enabled != null)
        ? configuration.videoV2Enabled
        : false;

      const idpToken = await getToken();

      dispatch({
        type: actionTypes.SET_VIDEO_V2_CONFIGURATION,
        data: { videoV2Configuration: { idpToken, isVideoV2Enabled } },
      });
    } catch (error) {
      dispatch({ type: actionTypes.SET_VIDEO_V2_CONFIGURATION_FAILURE });
    }
  };
};

const getVideoPlayerScript = (configuration) => {
  return async (dispatch) => {
    jQuery.getScript(configuration.videoPlayerCdn, ((data, textStatus, jqxhr) => {
      dispatch({ type: actionTypes.SET_VIDEO_PLAYER_LOAD_SUCCESS });
    }))
      .fail((jqxhr, settings, exception) => {
        dispatch({ type: actionTypes.SET_VIDEO_PLAYER_LOAD_FAILURE });
      });    
  };
};

export const loadVideoCreator = (companyId) => {
  return async (dispatch, getState) => {

    const dispatchFailures = () => {
      dispatch({ type: actionTypes.GET_VIDEO_CONFIGURATION_FAILURE });
      dispatch({ type: actionTypes.SET_VIDEO_V2_CONFIGURATION_FAILURE });
    };

    try {
      //if video creator is loaded, don't continue
     if (getState().video.isVideoCreatorLoaded) return;
     
     //if video creator is not loaded, continue
     jQuery.ajaxSetup({ cache: true });

     //get video configuration
      let videoConfiguration = getState().video.configuration;

      //if video configuration is not loaded, continue
      if (!videoConfiguration) {
        dispatch({ type: actionTypes.GET_VIDEO_CONFIGURATION_BEGIN });
  
        let response = await VideoApiService.getVideoConfiguration(companyId);
  
        if (response) {
          let configuration = response;
          dispatch({ type: actionTypes.GET_VIDEO_CONFIGURATION_SUCCESS, data: { configuration } });
          dispatch(getVideoCreatorScript(configuration));
          dispatch(setVideoV2Configuration(configuration));
          dispatch(getVideoPlayerScript(configuration));
        }
        else {
          dispatchFailures();
        }
      }
      //if video configuration is loaded, continue
      else {
        dispatch(getVideoCreatorScript(videoConfiguration));
        dispatch(setVideoV2Configuration(videoConfiguration));
        dispatch(getVideoPlayerScript(videoConfiguration));
      }
    } catch (error) {
      dispatchFailures();
    }
  
  };
};

const getVideoCreatorScript = (configuration) => {
  return async (dispatch) => {
    if (window.pctyVideo) return;

    jQuery.getScript(configuration.videoCreatorCdn, ((data, textStatus, jqxhr) => {
      dispatch({ type: actionTypes.SET_VIDEO_CREATOR_LOAD_SUCCESS });
    }))
      .fail((jqxhr, settings, exception) => {
        // if it failed, get the fallback
        jQuery.getScript(configuration.videoCreatorCdnFallback, ((data, textStatus, jqxhr) => {
          dispatch({ type: actionTypes.SET_VIDEO_CREATOR_LOAD_SUCCESS });
        }))
          .fail((jqxhr, settings, exception) => {
            dispatch({ type: actionTypes.SET_VIDEO_CREATOR_LOAD_FAILURE });
          });
      });
  };
};